import React from 'react';
import PropTypes from 'prop-types';

const PolymorphicElement = React.forwardRef(({ tag: Tag, children, ...props }, ref) => {
	return (
		// eslint-disable-next-line react/jsx-props-no-spreading
		<Tag ref={ref} {...props}>
			{children}
		</Tag>
	);
});
PolymorphicElement.propTypes = {
	tag: PropTypes.string,
	children: PropTypes.node.isRequired,
};
PolymorphicElement.defaultProps = {
	tag: 'div',
};

export default PolymorphicElement;
